import React, { useEffect, useState } from 'react';
import './style.css';
import { Row, Col, Table, Input, Spin, Button, DatePicker, Select, Tabs } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import toast, { Toaster, ToastBar } from 'react-hot-toast';
import { SearchOutlined, PlusOutlined } from '@ant-design/icons';
import { Link, useHistory, Redirect } from "react-router-dom";
import { getStatusTable, viewDashboardSelector, clearState } from './ClerkDashboardSlice';
import moment from 'moment';


const { Search } = Input;
const { TabPane } = Tabs;
const { RangePicker } = DatePicker;

export default function DispatchedStatus(props) {
    const { Option } = Select;
    const dispatch = useDispatch();
    let history = useHistory();
    const [isLoading, setLoading] = React.useState(false);
    const [isToast, setToast] = React.useState(false);
    const [AllDispatchedData, setDataSource] = useState([]);
    const [page, setPage] = useState(1);
    const [currentTab, setcurrentTab] = useState('dispatched');
    const [search, setSearch] = useState('');

    const { isTableDataSuccess, statusTabledata, statusCount } = useSelector(
        viewDashboardSelector
    );

    useEffect(() => {
        if (isTableDataSuccess) {
            setDataSource(statusTabledata);
            dispatch(clearState());
        }
    }, [isTableDataSuccess, statusTabledata, statusCount]);

    const renderContent = (value, row, index) => {
        const obj = {
            children: value,
            props: {},
        };
        return obj;
    };
    const columns = [
        {
            title: "File Reference",
            dataIndex: "reference_no",
            render: renderContent,
        },
        {
            title: "Control No",
            dataIndex: "control_no",
            render: renderContent,
        },
        {
            title: "Subject",
            dataIndex: "subject",
            render: (text, row, index) => {
                return {
                    children: <a onClick={(e) => handleStatusTableClick(row, e)}>{text}</a>
                };
            },
        },
        // {
        //     title: "Date",
        //     dataIndex: "date",
        //     render: renderContent,
        // },
        {
            title: "To",
            dataIndex: "from",
            render: renderContent,
        },
        // {
        //     title: "To",
        //     dataIndex: "to",
        //     render: renderContent,
        // },
    ];


    function onDateIncomingChange(value, dateString) {
        // console.log('Selected Time: ', moment(value).format());
        //  let data = `isStatus=${currentTab}&date=2021-09-16T07:27:14.194+00:00`;
        //    2021-09-21T00: 00: 00 + 05: 30
        if (dateString) {
            console.log('Formatted Selected Time: ', moment(dateString).format('YYYY-MM-DD'));
            let data = `page=${page}&limit=10&isStatus=${currentTab}&date=${moment(dateString).format('YYYY-MM-DD')}`;
            dispatch(getStatusTable(data));

        }
        else {
            let data = `isStatus=${currentTab}&page=${page}&limit=10&&date=${moment().format('YYYY-MM-DD')}`;
            dispatch(getStatusTable(data));
        }

    }

    const handleStatusTableClick = (row, e) => {
        history.push({
            pathname: '/view-process',
            state: { processName: row.action }
        });

    }

    let dataSourceIncoming = isLoading
        ? []
        : AllDispatchedData && AllDispatchedData.length > 0 ? AllDispatchedData.map((row, key) => ({
            id: row._id,
            reference_no: row && row.referenceNumber_ != null ? row.referenceNumber_ : 'N/A',
            control_no: row && row.controlNumber != null ? row.controlNumber : 'N/A',
            subject: row && row.processSubject != null ? row.processSubject : 'N/A',
            // date: moment(row.created_at).format("ll"),
            from: row && row.username != null ? row.username : 'N/A',
            to: row && row.next_username != null ? row.next_username : 'N/A',
            action: row.processId,
        }))
            : [];


    const ChangeIncomingPagination = (v) => {

        if (search) {
            let q = '&keyword=' + search + '&page=' + v.current + '&limit=10';
            dispatch(getStatusTable(q)).then(res => {
                if (res) {
                    let udata = res.data;
                    setDataSource(udata);
                    setPage(v.current);
                }
            });
        }
        else {
            let q = 'isStatus=' + currentTab + '&page=' + v.current + '&limit=10';
            setPage(v.current);
            dispatch(getStatusTable(q));
        }
    }



    return (
        <>
            <Row style={{ width: '100%' }}>
                <Col span="24" style={{ padding: '0px 20px 20px 20px' }}>
                    <Input placeholder="Search by typing complete reference number" size="large" suffix={<SearchOutlined />} style={{ width: '380px', marginRight: '20px' }}
                        onChange={e => {
                            const currValue = e.target.value;
                            setSearch(currValue);


                            if (currValue) {
                                let q = 'keyword=' + currValue + '&isStatus=' + currentTab + '&page=' + page + '&limit=10';
                                dispatch(getStatusTable(q)).then(res => {
                                    if (res) {
                                        let udata = res.data;
                                        setDataSource(udata);
                                        //setPage(1);
                                    }
                                });
                            }
                            else {
                                let q = 'isStatus=' + currentTab + '&page=' + page + '&limit=10';
                                dispatch(getStatusTable(q)).then(res => {
                                    if (res) {
                                        let udata = res.data;
                                        setDataSource(udata);
                                        setPage(1);
                                    }
                                });
                            }

                        }}

                    />
                    <DatePicker onChange={onDateIncomingChange} defaultValue={moment()} size="large" format={'ll'} style={{ marginRight: '10px' }} />
                    {/* <Button size="small" style={{ borderRadius: 5, padding: '6.4px 8px', fontWeight: 300, fontSize: 15 }} type="link" ghost>Reset</Button> */}
                </Col>
            </Row>

            {/* table code.. */}

            <Table
                columns={columns}
                onChange={ChangeIncomingPagination}
                pagination={{
                    // position: [ntop, nbottom],
                    size: "small",
                    defaultPageSize: 10,
                    total: statusCount ? statusCount : 0,
                    hideOnSinglePage: true,
                }}
                dataSource={dataSourceIncoming}
                className="clerk-dashboard-tab-sec-incoming"
                bordered
            />
        </>
    );
}